<!-- Modo AFTER: botões exibidos inline na interface -->
@if (timing === 'after' && buttons?.length > 0) {
  <div class="pgc-custom-buttons-container">
    @for (button of buttons; track button.id) {
      <po-button
        [p-label]="button.label"
        [p-icon]="button.icon || ''"
        [p-kind]="button.kind || 'secondary'"
        [p-disabled]="button.disabled || !!executingAction"
        [p-loading]="isExecuting(button)"
        [p-tooltip]="button.tooltip || ''"
        (p-click)="executeButtonAction(button)">
      </po-button>
    }
  </div>
}

<!-- Modo BEFORE: modal aberto antes de carregar a listagem -->
@if (timing === 'before') {
  <po-modal
    #customButtonsModal
    [p-title]="modalTitle"
    p-size="md"
    [p-secondary-action]="secondaryModalAction"
    p-hide-close="false">

    <div class="pgc-custom-buttons-modal-content">
      <div class="pgc-custom-buttons-modal-options">
        @for (button of buttons; track button.id) {
          <div class="pgc-custom-buttons-modal-option">
            <po-button
              [p-label]="button.label"
              [p-icon]="button.icon || ''"
              [p-kind]="button.kind || 'primary'"
              [p-disabled]="button.disabled || !!executingAction"
              [p-loading]="isExecuting(button)"
              [p-tooltip]="button.tooltip || ''"
              (p-click)="executeButtonAction(button)">
            </po-button>
            @if (button.description) {
              <span class="pgc-custom-buttons-option-desc">{{ button.description }}</span>
            }
          </div>
        }
      </div>
    </div>

  </po-modal>
}
